
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"16","viewBox":"0 0 24 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M19.637 10.896l.56-.26-1.737-3.725-2.205-4.733a.308.308 0 00-.36-.167l-1.701.456.16.596 1.452-.39.485 1.04c-.725.012-4.652.164-5.492 2.023H7.89l-1.294-.66a2.535 2.535 0 00-.97-.27l-2.092-.15a.619.619 0 00-.598.341l-.08.162a.663.663 0 00-.036.507l.006.02-1.736 1.57.232.257 1.664-1.506 3.182.426.04.005.085.147-2.077 3.31h.737l1.692-2.697.106.184 1.445 2.514.107.187H3.308v.686h5.39l.088.154.013.02.008.013c.287.473.801.764 1.357.764h3.996l2.095-4.308h-2.371v-.19h2.463l.143-.294h-3.637v-.19h3.814l.925-.232.318.683 1.727 3.707zm-.663-3.52a3.213 3.213 0 11-1.046.489l.52 1.115c-.415.37-.678.908-.678 1.507 0 1.111.905 2.016 2.016 2.016a2.019 2.019 0 002.017-2.016 2.019 2.019 0 00-2.31-1.996l-.519-1.114zm-14.76 5.127a2.019 2.019 0 01-2.017-2.016 2.019 2.019 0 012.632-1.92l.65-1.034A3.213 3.213 0 104.213 13.7a3.214 3.214 0 003.179-2.745H6.174a2.02 2.02 0 01-1.96 1.547zm1.928-2.607h1.23a3.21 3.21 0 00-1.049-1.833l-.649 1.035c.213.224.375.496.468.798zm12.706-6.47c.583 0 .583 2.108 0 2.108a1.055 1.055 0 010-2.108z","fill":"currentColor"}})])
          )
        }
      }
    